import { Language } from '~/store/layout';
import en from '../locales/en.json';
import he from '../locales/he.json';

interface LangLine<T> {
  [s: string]: T;
}

interface LangObj {
  [key: string]: LangObj | string;
}

class Translation {
  public language: string;
  constructor(language: string = Language.en) {
    this.language = language;
  }

  public t(word: string, replace: { [key: string]: string } = {}) {
    const file: LangLine<LangObj> = {
      EN: en,
      HE: he,
    };

    const lang: LangObj = file[this.language];

    let result: string = (
      word.split('.').reduce((o: LangObj | string, i: string) => (typeof o === 'object' ? o[i] : '-'), lang) || '-'
    ).toString();
    const replaceArr = Object.keys(replace);

    if (result !== '' && replaceArr.length !== 0) {
      replaceArr.forEach((key) => {
        result = result.replace(`:${key}`, replace[key]);
      });
    }

    return result;
  }

  public setLang(language: string) {
    this.language = language;
  }
}

// TODO add set default language
const translation = new Translation('EN');

export { translation as t };
